export const APP_STATUS_CHANGE = 'APP_STATUS_CHANGE';
export const GRID_ROWS_REQUEST = 'GRID_ROWS_REQUEST';
export const GRID_ROWS_RECEIVE_SUCCESS = 'GRID_ROWS_RECEIVE_SUCCESS';
export const GRID_ROWS_RECEIVE_FAIL = 'GRID_ROWS_RECEIVE_SUCCESS';
export const GRID_STATUS_CHANGE = 'GRID_STATUS_CHANGE';
export const LOG_CHANGE = 'LOG_CHANGE';

export const GAME_ANSWER_REQUEST = 'GAME_ANSWER_REQUEST';
export const GAME_ANSWER_RECEIVED_SUCCESS = 'GAME_ANSWER_RECEIVED_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/types/types.js